/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostingfbreelhint3Inputs */

const en_crosspostingfbreelhint3 = /** @type {(inputs: Crosspostingfbreelhint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vertical video (9:16) for Pages.`)
};

const de_crosspostingfbreelhint3 = /** @type {(inputs: Crosspostingfbreelhint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vertikales Video (9:16) für Seiten.`)
};

/**
* | output |
* | --- |
* | "Vertical video (9:16) for Pages." |
*
* @param {Crosspostingfbreelhint3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingfbreelhint3 = /** @type {((inputs?: Crosspostingfbreelhint3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingfbreelhint3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingfbreelhint3(inputs)
	return de_crosspostingfbreelhint3(inputs)
});
export { crosspostingfbreelhint3 as "crosspostingFbReelHint" }